import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	labsSectionTitle: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.labs-section-title',
		defaultMessage: 'Feature lab',
		description: 'Title text of the Labs features section',
	},
	labsSectionDescription: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.labs-section-description',
		defaultMessage:
			"The feature lab lets us test new ideas and get real-world feedback to improve them. They're works in progress, so they can change or break, and may not end up released at all. {learnMoreLink}.",
		description:
			'Description that explains the purpose of the labs section of the page to the user',
	},
	labsDocsLink: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.labs-docs-link',
		defaultMessage: 'Learn more about the feature lab',
		description: 'Text used in link to the docs that explains the Labs features',
	},
	similarRequestsPanelTitle: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.similar-requests-panel-title',
		defaultMessage: 'Similar requests panel',
		description: 'Title text of the similar requests panel',
	},
	similarRequestsPanelDescription: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.similar-requests-panel-description',
		defaultMessage:
			"Your team can view other issues in the project that are related to the one they're viewing. This works for all issues types on Jira Service Management (service requests, incidents, problems, changes, and post-incident reviews). {learnMoreLink}.",
		description: 'Description that explains what the Similar requests panel does',
	},
	similarRequestsLink: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.similar-requests-link',
		defaultMessage: 'Learn more about the similar requests panel',
		description: 'Text used in alerts learn more link',
	},
	issueViewTitle: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.issue-view-title',
		defaultMessage: 'Issue view',
		description: 'Title text of the issue view lab feature group',
	},
	itsmTitle: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.itsm-title',
		defaultMessage: 'ITSM categories',
		description: 'Title text of the ITSM lab feature group',
	},
	defaultRequestTypesTitle: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.default-request-types-title',
		defaultMessage: 'Default request types',
		description: 'Title text of the default request types features panel',
	},
	defaultRequestTypesDescription: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.default-request-types-description',
		defaultMessage:
			"When you change the issue type of an issue, we'll automatically update the issue's request type. Choose a default request type for each of your issues types by editing the default request type settings. {learnMoreLink}.",
		description: 'Description text of the default request types features panel',
	},
	defaultRequestTypesLink: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.default-request-types-link',
		defaultMessage: 'Learn more about default request types',
		description: 'Text used for the the default request types learn more link',
	},
	defaultRequestTypeSettingsButtonText: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.default-request-type-settings-button-text',
		defaultMessage: 'Default request type settings',
		description: 'Text of default request type settings button',
	},
	jsmBoardGroupTitle: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.jsm-board-group-title',
		defaultMessage: 'Boards',
		description: 'Title text of the JSM board features group',
	},
	jsmBoardTitle: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.jsm-board-title',
		defaultMessage: 'Board',
		description: 'Title text of the JSM boards features panel',
	},
	jsmBoardDescription: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.jsm-board-description',
		defaultMessage:
			"Visualize your work with a board to track the progress of all issues in your project. Add, rename, or remove columns in your board to match your team's preferred way of working. {learnMoreLink}.",
		description: 'Description text of the JSM board features panel',
	},
	jsmBoardLink: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.jsm-board-link',
		defaultMessage: 'Learn more about setting up a board',
		description: 'Text used for the the JSM board learn more link',
	},
	newLozenge: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.new-lozenge',
		defaultMessage: 'New',
		description:
			'Small lozenge that appears to the right of the board title, indicating a new feature.',
	},
	sentimentFieldTitle: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.sentiment-field-title',
		defaultMessage: 'Customer sentiment analysis',
		description: 'Title text of the sentiment panel',
	},
	sentimenFieldDescription: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.sentimen-field-description',
		defaultMessage:
			'Show customer sentiment on issues to quickly understand how customers are feeling. Customer sentiment is determined by content in the issue and the activity feed. {learnMoreLink}.',
		description: 'Description that explains what the sentiment panel does',
	},
	sentimentLink: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.sentiment-link',
		defaultMessage: 'Read more about sentiment analysis',
		description: 'Text used in alerts learn more link',
	},
	sentimentFeaturePrerequisiteTooltip: {
		id: 'servicedesk-itsm-features.app.sections.labs-section.sentiment-feature-prerequisite-tooltip',
		defaultMessage:
			'To use this feature, your Jira admin needs to <link> enable Atlassian Intelligence.</link>',
		description: 'Body text for practice navigation spotlight card.',
	},
});
